import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndrawCollection = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 766 590",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffb8b8",
			d: "M100.636 576.086h12.259l5.833-47.288-18.095.001.003 47.287z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.508 572.084l24.144-.001h.001a15.386 15.386 0 0115.387 15.386v.5l-39.53.002z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffb8b8",
			d: "M50.636 576.086h12.259l5.833-47.288-18.095.001.003 47.287z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.508 572.084l24.144-.001h.001a15.386 15.386 0 0115.387 15.386v.5l-39.53.002zM52.994 555.783a4.505 4.505 0 01-4.484-4.227L37.642 373.829l73.138 7.892 10.785 159.312a4.516 4.516 0 01-3.582 4.712l-14.511 2.99a4.5 4.5 0 01-5.335-3.6l-17.73-97.2a.47.47 0 00-.511-.409.48.48 0 00-.479.448L68.831 548.3a4.493 4.493 0 01-3.166 3.833l-11.354 3.454a4.526 4.526 0 01-1.317.196z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 54.38,
			cy: 218.424,
			r: 24.561,
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.019 384.84l-16.591-89.172a37.743 37.743 0 0126.6-43.262 37.857 37.857 0 0148.006 30.4l15.858 99.85z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.6 400.522a10.056 10.056 0 01-1.747-15.32l-16.396-31.751 18.465 1.97 12.739 29.85A10.11 10.11 0 0147.6 400.522z",
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.038 379.626a4.505 4.505 0 01-3.195-1.804L20.291 351.39a46.373 46.373 0 01-8.937-31.397l3.04-36.912a14.497 14.497 0 1128.728-3.919l-1.779 58.72L53.88 367.6a4.515 4.515 0 01-1.091 5.054l-6.274 5.797a4.506 4.506 0 01-2.426 1.15 4.455 4.455 0 01-1.05.025z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.82 205.042a10.056 10.056 0 01-13.427 7.582l-22.846 27.478-5.384-17.772 22.52-23.369a10.11 10.11 0 0119.137 6.08z",
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.356 217.39a4.505 4.505 0 01-.416 3.645l-16.717 28.31a46.373 46.373 0 01-25.427 20.472l-35.177 11.592a14.497 14.497 0 11-14.809-24.926l54.766-21.256 22.478-23.133a4.515 4.515 0 015.08-.965l7.784 3.517a4.506 4.506 0 012.006 1.786 4.454 4.454 0 01.432.958z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M34.459 303.589l1 32L53.88 367.6l-15.382-35.674-4.039-28.337z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.194 223.04a6.423 6.423 0 007.03-4.703 9.764 9.764 0 016.952-7.273c4.505-1.03 10.012 1.09 13.313-2.323a6.638 6.638 0 001.576-5.842c-.609-3.317-2.981-5.823-5.564-7.828a34.062 34.062 0 00-18.866-7.05 67.677 67.677 0 00-10.62.528 47.009 47.009 0 00-10.864 1.985 25.576 25.576 0 00-16.002 18.68 29.528 29.528 0 006.057 24.131 31.702 31.702 0 0012.16 9.259 4.744 4.744 0 003.607.183c2.957-1.176 2.474-4.84 1.125-7.283-1.443-2.615-3.663-5.146-2.502-8.328a6.302 6.302 0 013.127-3.367c2.94-1.499 6.228-1.144 9.389-.78z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M748.866 564h-437a17.02 17.02 0 01-17-17V17a17.02 17.02 0 0117-17h437a17.02 17.02 0 0117 17v530a17.02 17.02 0 01-17 17zm-437-562a15.017 15.017 0 00-15 15v530a15.017 15.017 0 0015 15h437a15.017 15.017 0 0015-15V17a15.017 15.017 0 00-15-15z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3f3d56",
			d: "M295.866 41.59h469v2h-469z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 318.866,
			cy: 22,
			r: 8,
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 343.866,
			cy: 22,
			r: 8,
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 368.866,
			cy: 22,
			r: 8,
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M681.126 115h-312a13 13 0 010-26h312a13 13 0 010 26zm-312-24a11 11 0 000 22h312a11 11 0 000-22z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M676.162 262.91h-304a16.519 16.519 0 01-16.5-16.5v-65a16.519 16.519 0 0116.5-16.5h304a16.519 16.519 0 0116.5 16.5v65a16.519 16.519 0 01-16.5 16.5zM676.162 388.91h-304a16.519 16.519 0 01-16.5-16.5v-65a16.519 16.519 0 0116.5-16.5h304a16.52 16.52 0 0116.5 16.5v65a16.52 16.52 0 01-16.5 16.5zM676.162 514.91h-304a16.519 16.519 0 01-16.5-16.5v-65a16.519 16.519 0 0116.5-16.5h304a16.52 16.52 0 0116.5 16.5v65a16.52 16.52 0 01-16.5 16.5z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M502.162 254.91h-304a16.519 16.519 0 01-16.5-16.5v-65a16.519 16.519 0 0116.5-16.5h304a16.519 16.519 0 0116.5 16.5v65a16.519 16.519 0 01-16.5 16.5z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M502.161 255.41h-304a17.02 17.02 0 01-17-17v-65a17.02 17.02 0 0117-17h304a17.02 17.02 0 0117 17v65a17.02 17.02 0 01-17 17zm-304-97a15.017 15.017 0 00-15 15v65a15.017 15.017 0 0015 15h304a15.017 15.017 0 0015-15v-65a15.017 15.017 0 00-15-15z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M465.161 238.91h-230a16.519 16.519 0 01-16.5-16.5v-34a16.519 16.519 0 0116.5-16.5h230a16.519 16.519 0 0116.5 16.5v34a16.519 16.519 0 01-16.5 16.5z",
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 284.656,
			cy: 200.852,
			r: 19.732,
			fill: "#ff6584"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M450.868 236.918l-27.852-23.36-27.372-22.956a4 4 0 00-5.153.01l-27.283 23.062-6.664 5.633-10.048-8.427-30.537-25.611a4 4 0 00-5.153.01l-30.438 25.728-30.917 26.133a1 1 0 00.648 1.764l63.387-.122 20.064-.039-.197.166 59.808-.115 57.067-.11a1 1 0 00.64-1.766zM193 589.41H1a1 1 0 110-2h192a1 1 0 010 2z",
			fill: "#3f3d56"
		})
	]
});
export default SvgUndrawCollection;
